module.exports = __webpack_public_path__ + "img/lc.3995dda7.svg";